<table class="wave2-table margin-rank" *ngIf="rankedRows.length">
  <thead>
    <tr>
      <th>{{ 'dashboard.company.col_client' | translate }}</th>
      <th>{{ 'dashboard.company.col_margin' | translate }}</th>
      <th>{{ 'dashboard.company.col_margin_pct' | translate }}</th>
      <th>{{ 'dashboard.company.col_revenue' | translate }}</th>
      <th>{{ 'dashboard.company.col_share' | translate }}</th>
      <th>{{ 'dashboard.company.col_consultants' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rankedRows; trackBy: trackByRow">
      <td>{{ row.name || (row.kind === 'other' ? ('dashboard.company.row_other' | translate) : ('dashboard.company.row_unknown' | translate)) }}</td>
      <td class="margin-cell">
        <span class="mc-dash" *ngIf="row.marginEuros === null">—</span>
        <span class="mc-wrap" *ngIf="row.marginEuros !== null">
          <span class="mc-track" [class.zero-centred]="hasNegative">
            <ng-container *ngIf="hasNegative">
              <i class="mc-mid"></i>
              <i class="mc-neg" [style.width.%]="row.negPct"></i>
              <i class="mc-pos" [style.width.%]="row.posPct"></i>
            </ng-container>
            <i class="mc-plain" *ngIf="!hasNegative" [style.width.%]="row.barPct"></i>
          </span>
          <span class="mc-val" *ngIf="!row.underFloor">{{ '€' + (row.marginEuros | number:'1.0-0') }}</span>
          <span class="mc-val" *ngIf="row.underFloor">{{ 'dashboard.company.margin_under_floor' | translate }}</span>
          <span class="kchip chip-critical mc-chip" *ngIf="row.isLoss">
            <nb-icon icon="close-circle-outline" aria-hidden="true"></nb-icon>
            <span>{{ 'dashboard.company.margin_loss' | translate }}</span>
          </span>
        </span>
      </td>
      <td class="num-strong">{{ row.marginPct !== null ? (row.marginPct + '%') : '—' }}</td>
      <td>{{ row.revenue !== null ? ('€' + (row.revenue | number:'1.0-0')) : '—' }}</td>
      <td class="share-cell">
        <span class="sc-dash" *ngIf="row.sharePct == null">—</span>
        <span class="sc-wrap" *ngIf="row.sharePct != null">
          <span class="sc-val">{{ row.sharePct }}%</span>
          <span class="sc-track"><i [style.width.%]="row.sharePct"></i></span>
        </span>
      </td>
      <td>{{ row.consultants }}</td>
    </tr>
  </tbody>
</table>
